import React from "react";

const StepBarIndicator = props => {
	return (
		<span
			className="step-bar-indicator"
			style={{ width: `${100 / props.total * props.currentStep}%` }}
		/>
	);
};

export default StepBarIndicator;
